import FirebaseApp from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
import store from '@/store'

const firebaseConfig = {
  apiKey: "AIzaSyAItFBKROSLVBiTP3KfZiQ45j23it_pvDw",
  authDomain: "michaeliscabin-4d1e9.firebaseapp.com",
  databaseURL: "https://michaeliscabin-4d1e9.firebaseio.com",
  projectId: "michaeliscabin-4d1e9",
  storageBucket: "michaeliscabin-4d1e9.appspot.com",
  messagingSenderId: "1034479046464",
  appId: "1:1034479046464:web:17e584d9bdc2ee750034a5",
  measurementId: "G-BPEQKX9SPN"
}
const firebaseApp = FirebaseApp.initializeApp({
  ...firebaseConfig
})

firebaseApp.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
      const unsubscribe = firebaseApp.auth().onAuthStateChanged(user => {
        if (user) {
          store.commit('SET_USER', user)
        } else {
          store.commit('SET_USER', null)
        }
        unsubscribe()
        resolve(user)
      }, reject)
  })
}
// Export the database for components to use.
// If you want to get fancy, use mixins or provide / inject to avoid redundant imports.
export const db = firebaseApp.firestore()
export const storage = firebaseApp.storage()
export const auth = firebaseApp.auth()
export default firebaseApp